import { IProjectLoanType } from '~/@api/generated-api-types-project/Api'

const projectLoanType = {
  [IProjectLoanType.AssetBasedLoan]: 'Asset Based Loan',
}

export function getProjectLoanTypeLabel(key: IProjectLoanType) {
  return projectLoanType[key]
}
